import { generatePath } from 'react-router'
import { unifiedFlowPaths } from 'app/navigation/paths'

import Button from 'common/components/button/Button'
import SubNavBar, { SubNavItem } from 'common/components/navigation/subNavBar'
import Tooltip from 'common/components/Tooltip'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { Menu as MenuIcon } from 'common/icons'
import {
  hideLeftPanel,
  showLeftPanel,
} from 'features/unifiedFlow/store/unifiedFlowSlice'

import { getIsAtleastOneElementGenerationComplete } from '../../helpers'
import useContent from '../../hooks/useContent'

import HeaderActions from './HeaderActions'

const Header = () => {
  const dispatch = useAppDispatch()

  const isLeftPanelVisible = useAppSelector(
    (state) => state.unifiedFlow.isLeftPanelVisible
  )

  const { content } = useContent()

  const workflowName = content?.display_name

  const isIntegrationPageEnabled =
    getIsAtleastOneElementGenerationComplete(content)

  return (
    <SubNavBar
      title={workflowName}
      preTitle={
        <Button
          className="pr-1 md:hidden pl-0"
          prefixIcon={
            <Tooltip overlay={isLeftPanelVisible ? 'Hide panel' : 'Show panel'}>
              <MenuIcon />
            </Tooltip>
          }
          onClick={() => {
            isLeftPanelVisible
              ? dispatch(hideLeftPanel())
              : dispatch(showLeftPanel())
          }}
        />
      }
      backLink={unifiedFlowPaths.home}
    >
      {content && (
        <>
          <SubNavItem
            key="unified-flow-content-brief"
            to={generatePath(unifiedFlowPaths.brief, {
              contentId: content._id,
            })}
            title="Brief"
          />
          <SubNavItem
            key="unified-flow-content-generate"
            to={generatePath(unifiedFlowPaths.generate, {
              contentId: content._id,
            })}
            title="Generate"
          />
          <SubNavItem
            key="unified-flow-content-approvals"
            to={generatePath(unifiedFlowPaths.approvals, {
              contentId: content._id,
            })}
            title="Approvals"
          />
          <SubNavItem
            key="unified-flow-content-integrations"
            to={generatePath(unifiedFlowPaths.integrations, {
              contentId: content._id,
            })}
            title="Integrations"
            isDisabled={!isIntegrationPageEnabled}
          />
          <SubNavItem
            key="unified-flow-content-results"
            to={generatePath(unifiedFlowPaths.results, {
              contentId: content._id,
            })}
            title="Results"
          />
        </>
      )}
      <HeaderActions />
    </SubNavBar>
  )
}

export default Header
